interface SelectionToolbarProps {
  count: number
  totalCount: number
  onSelectAll: () => void
  onDeselectAll: () => void
  onDownload: () => void
  onDelete: () => void
  onCancel: () => void
  isDownloading?: boolean
}

export function SelectionToolbar({
  count,
  totalCount,
  onSelectAll,
  onDeselectAll,
  onDownload,
  onDelete,
  onCancel,
  isDownloading = false,
}: SelectionToolbarProps) {
  const allSelected = count === totalCount && totalCount > 0

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40
      max-w-lg w-[calc(100%-32px)] bg-white/95 backdrop-blur-md
      border border-border-color rounded-2xl shadow-lg px-5 py-3
      animate-[toolbar-slide-up_0.3s_ease-out]">
      <div className="flex items-center justify-between gap-4">
        {/* Selected count */}
        <span className="text-sm font-medium text-text-main whitespace-nowrap">
          {count} selected
        </span>

        {/* Actions */}
        <div className="flex items-center gap-2">
          {/* Select All / Deselect All */}
          <button
            onClick={allSelected ? onDeselectAll : onSelectAll}
            className="px-3 py-1.5 rounded-lg text-xs font-medium text-text-muted hover:text-text-main hover:bg-surface-muted transition-colors"
          >
            {allSelected ? 'Deselect All' : 'Select All'}
          </button>

          {/* Divider */}
          <div className="w-px h-5 bg-border-color" />

          {/* Download button */}
          <button
            onClick={onDownload}
            disabled={isDownloading}
            className="size-9 rounded-lg flex items-center justify-center text-text-main hover:text-primary hover:bg-primary/5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            title="Download selected"
          >
            {isDownloading ? (
              <div className="w-4 h-4 border-2 border-primary/20 border-t-primary rounded-full animate-spin" />
            ) : (
              <span className="material-symbols-outlined text-lg">download</span>
            )}
          </button>

          {/* Delete button */}
          <button
            onClick={onDelete}
            className="size-9 rounded-lg flex items-center justify-center text-red-600 hover:bg-red-50 transition-colors"
            title="Delete selected"
          >
            <span className="material-symbols-outlined text-lg">delete</span>
          </button>

          {/* Close/Cancel button */}
          <button
            onClick={onCancel}
            className="size-9 rounded-lg flex items-center justify-center text-text-muted hover:text-text-main hover:bg-surface-muted transition-colors"
            title="Cancel selection"
          >
            <span className="material-symbols-outlined text-lg">close</span>
          </button>
        </div>
      </div>
    </div>
  )
}
